import {Map} from 'immutable';

import SortableTable from './SortableTable';

export default Map({
  renderer: SortableTable,
  type: 'sortable-table',
  label: 'Sortable Table'
});
